import { useSubmitAppController } from "./SubmitApp.controller";
import { SubmitAppPresentation } from "./SubmitApp.pres";

export const ConnectSubmitApp = () => {
  const presentationProps = useSubmitAppController();

  return <SubmitAppPresentation {...presentationProps} />;
};
